import {
  SensorType,
  useGetEnergySavingData as useGetEnergySavingDataCommon,
} from "common";
import { useTranslation } from "react-i18next";

import { useGetSensorRollupByType } from "../sensors/useGetSensorRollupByType";

export const useGetEnergySavingData = (days) => {
  const { t } = useTranslation();
  const { historicalData } = useGetSensorRollupByType(SensorType.POWER, days);
  return useGetEnergySavingDataCommon({
    historicalData,
    translate: (str) => t(str),
  });
};
